import React, { useState, useEffect } from "react"

import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory, withRouter, useParams } from "react-router-dom";

import clsx from 'clsx';

import { Button, Grid, Divider, Typography, TextField, Slider, FormHelperText, CircularProgress, IconButton } from "@material-ui/core"
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { getDataModelById, getContractDataById, createDocument, clearReduxDataOfCurrentComponent, updateDataModelData } from '../../../store/actions';

import { Helpers } from "dsilo-ui-components";

import { Loader } from '../../loader';

import WysiwygEditor from './WysiwygEditor';

import useStyles from "../styles";

const ClauseData = (props) => {
    const classes = useStyles()
    const history = useHistory()
    const { id: _id, sdid } = useParams();
    const {isNewV1Theme} = props;
    const { setIsClauseView, allDataElementforClause, setAllDataElementsforClause } = props
    const { chartData, chartUniqueId } = props.data

    const [state, setState] = useState({})
    const [threshold, setThreshold] = useState(10);
    const [selectedClause, setSelectedClause] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    // const [allDataElementforClause, setAllDataElementsforClause] = useState({})

    let subDataElements = chartData?.subDataElement
    let dataUniqueId = chartData.subDataModel;
    let mainDataModelDataElement = props?.formData?.dataModel?.[dataUniqueId]?.mainDataModel?.dataElement
    let loader = props.formData[props.data.chartUniqueId + '_getClause' + '_loading']

    const clearCurrentChartReduxStore = () => {
        let subKeys = [
            chartUniqueId + '_get',
            chartUniqueId + '_getClause',
            // chartUniqueId + '_save',
            // chartUniqueId + '_update'
        ]

        props.clearReduxDataOfCurrentComponent({
            key: "document",
            subKey: subKeys
        })
    }

    useEffect(() => {
        let res = props.formData.document[props.data.chartUniqueId + '_getClause'];
        if (res?.data?.[0]) {
            let news = res?.data?.[0] || {}
            setSelectedClause({ ...selectedClause, ...news })
        }
    }, [props.formData.document[props.data.chartUniqueId + '_getClause']])

    useEffect(() => {
        if (props.formData?.dataModel?.[dataUniqueId]) {
            let dataElementsList = props.formData?.dataModel?.[dataUniqueId]?.dataElements || []
            let obj = {}
            dataElementsList.forEach(de => {
                obj[de.name] = de
            })
            setAllDataElementsforClause(obj)
        }
    }, [props.formData?.dataModel])

    useEffect(() => {
        let res = props.formData.document[chartUniqueId + '_save'];
        if (res) {
            toast.success(res.message || 'Document Created Successfully')
            // clearCurrentChartReduxStore();
            handleBack();
        }
    }, [props.formData?.document[chartUniqueId + '_save']])

    useEffect(() => {
        let res = props.formData.document[chartUniqueId + '_update'];
        if (res) {
            // clearCurrentChartReduxStore();
            handleBack();
        }
    }, [props.formData?.document[chartUniqueId + '_update']]);

    useEffect(() => {
        fetchDataModel();
        updateDefaultFields();
        getClauseData();

        return () => {
            clearCurrentChartReduxStore();
        };
    }, []);

    // Fetch Data Model
    const fetchDataModel = () => {
        let dataUniqueId = chartData.subDataModel;
        let dataModelId = chartData.subDataModel;

        if (!props.formData?.dataModel?.[dataUniqueId] && !props.formData[`${dataUniqueId}_loading}`]) {
            let payload = {
                appid: props.match.params.appid,
                orgId: props.appConfig?.org?._id,
                dataUniqueId,
                dataModelId,
            };
            props.getDataModelById(payload);
        }
    };

    //updating the fields
    const updateDefaultFields = () => {
        if (subDataElements?.length) {
            let isUpdated = false;
            let obj = {};
            subDataElements?.forEach((sd) => {
                if (sd.defaultValue) {
                    obj[sd.value] = sd.defaultValue;
                    isUpdated = true;
                }
            });

            if (isUpdated) {
                setState((prevState) => ({ ...prevState, ...obj }));
            }
        }
    };

    //  to Get the  Clause Data 
    const getClauseData = () => {
        if (sdid && sdid !== 'new') {
            let fields = subDataElements?.map((sd) => sd.value).join(",") || "";
            let payload = {
                id: sdid,
                dataModelId: chartData.subDataModel,
                appId: props.match.params.appid,
                fields: fields,
                dataUniqueId: chartUniqueId + "_getClause",
            };
            props.getContractDataById(payload);
        }
    };

    const onSaveClick = () => {
        let data = JSON.parse(JSON.stringify(selectedClause))
        subDataElements?.map((field) => {
            let de = allDataElementforClause[field.value];
            let type = de?.type;
            // Check if type is 'wysiwyg' and the key matches with data
            if (type === 'wysiwyg' && data[field.value] && typeof data[field.value] === 'string') {
                try {
                    // Parse the value of the key (field.value) as JSON if it's a string
                    data[field.value] = JSON.parse(data[field.value]);
                } catch (error) {
                    console.error(`Error parsing ${field.value}:`, error);
                }
            }
        })

        let isValid = true;
        subDataElements?.forEach(sd => {
            const value = data[sd.value];
            //checking if fields are empty or invalid
            if (sd.required && (value === undefined || value === null || (typeof value === "string" && value.trim() === "") || (typeof value === "number" && isNaN(value)))) {
                isValid = false;
            }

            if ((sd.hide || sd.readonly) && sd.defaultValue) {
                data[sd.value] = sd.defaultValue;
            }
        });
        // If validation fails, show an error
        if (!isValid) {
            setIsSubmitted(true);
            return;
        }
        //update request for updating the clause
        if (sdid && sdid !== 'new') {
            let formData = {
                appid: props.match.params.appid,
                dataModelId: props.data.chartData?.subDataModel,
                dataUniqueId: props.data.chartUniqueId + '_update',
                payload: data,
            }
            props.updateDataModelData(formData)
        } else {
            //adding the clause document
            let formData = {
                appid: props.match.params.appid,
                dataModelId: props.data.chartData?.subDataModel,
                dataUniqueId: props.data.chartUniqueId + '_save',
                payload: {
                    ...data,
                    [mainDataModelDataElement]: _id
                },
            }
            props.createDocument(formData)
        }
    }

    const handleThresholdChange = (event, newValue) => {
        setThreshold(newValue);
        setSelectedClause((prevClause) => ({
            ...prevClause,
            threshold: newValue,
        }));
    };

    const handleInputChange = (event, field) => {
        const { value } = event.target;
        setSelectedClause((prev) => ({
            ...prev,
            [field.value]: value,
        }));
    };

    const handleBack = () => {
        setIsClauseView(false)
        const lastPage = chartData.listPage;
        if (lastPage) {
            props.history.push({ pathname: `/${props.match.params.appid}/page/${lastPage}` });
        } else {
            history.goBack()
        }
    }

    // Helper function to count words in a string
    const countWords = (text) => {
        if (!text || typeof text !== 'string') return 0;
        return text.trim().split(/\s+/).filter(word => word.length > 0).length;
    }

    // Handler for textarea input with word limit
    const handleTextareaChange = (event, field, maxWords = 200) => {
        const { value } = event.target;
        const wordCount = countWords(value);
        // Character limit: approximately 1500 characters for 200 words (avg 7.5 chars per word)
        const maxCharacters = 1500;
        
        // Only update if both word count and character count are within limits
        if (wordCount <= maxWords && value.length <= maxCharacters) {
            handleInputChange(event, field);
        }
    }

    return (
        <div>
        {!isNewV1Theme ? (
        <>
            {
                loader ? <Loader /> :
                    <Grid style={{ width: "100%",overflow: "hidden" }}>
                        <div className={classes.clauseDataDiv}>
                            <h1>{props.page.clauseTitle}</h1>
                            <div style={{ marginTop: 10, display: "flex", gap: '10px' }}>
                                <Button
                                    color="primary" onClick={onSaveClick}
                                    style={{ textTransform: 'capitalize' }}
                                    variant="contained">
                                    {
                                        (Helpers.loading(props, '_save') || Helpers.loading(props, '_update')) ? <CircularProgress color='#fff' size={24} /> : (selectedClause._id ? "Update" : "Add")
                                    }
                                </Button>
                                <Button variant="contained" color="secondary" size='small' onClick={handleBack}>Back</Button>
                            </div>
                        </div>
                        <Divider />
                        <Grid container spacing={1} columnSpacing={2} xs={12} className={classes.clauseDataGrid}>
                            {subDataElements?.map((field) => {
                                let de = allDataElementforClause[field.value]
                                let type = de?.type

                                return (
                                    <Grid item
                                        className={clsx(classes.DataGridItem, {
                                            [classes.fullWidth]: type === 'textarea' || type === 'wysiwyg',
                                        })}
                                        key={field.value}>
                                        <Grid container alignItems="center" spacing={2} columnSpacing={5}>
                                            <Grid item className={classes.formLabel}>
                                                <Typography sx={{ textAlign: "right", fontWeight: "500" }}>
                                                    {field.label}{field.required && <span style={{ color: "#d32f2f" }}>*</span>}
                                                </Typography>
                                            </Grid>
                                            <Grid item className={classes.formInput}>
                                                {type === 'number' && field.uiType === "range" ? (
                                                    <>
                                                        <Slider
                                                            value={Number(selectedClause.threshold) || 0}
                                                            onChange={handleThresholdChange}
                                                            min={0}
                                                            max={100}
                                                            step={1}
                                                            valueLabelDisplay="on"
                                                            error={isSubmitted && selectedClause.threshold === undefined}
                                                        />
                                                        {isSubmitted && selectedClause.threshold === undefined && (
                                                            <FormHelperText error>This field is required</FormHelperText>
                                                        )}
                                                    </>
                                                ) : type === 'textarea' ? (
                                                    <TextField
                                                        multiline
                                                        minRows={3}
                                                        variant="outlined"
                                                        required={field.required}
                                                        error={isSubmitted && !selectedClause[field.value]}
                                                        className={classes.TextArea}
                                                        value={selectedClause[field.value] || ""}
                                                        onChange={(event) => handleInputChange(event, field)}
                                                        placeholder={'Enter ' + field.label}
                                                        helperText={isSubmitted && !selectedClause[field.value] ? "This field is required" : ""}
                                                    />
                                                ) : type === 'wysiwyg' ? (
                                                    <WysiwygEditor
                                                        value={selectedClause[field.value] || ""}
                                                        onChange={(val) => handleInputChange({ target: { value: val } }, field)}
                                                        error={isSubmitted && !selectedClause[field.value]}
                                                        required={field.required}
                                                        placeholder={'Enter ' + field.label}
                                                    />

                                                ) : (
                                                    <TextField
                                                        type={type === 'number' ? "number" : "text"}
                                                        variant="outlined"
                                                        error={isSubmitted && !selectedClause[field.value]}
                                                        className={classes.TextField}
                                                        value={selectedClause[field.value] || ""}
                                                        onChange={(event) => handleInputChange(event, field)}
                                                        placeholder={'Enter ' + field.label}
                                                        helperText={isSubmitted && !selectedClause[field.value] ? "This field is required" : ""}
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>
                    
            }
        </>
        ) : ( 
            <>
                {loader ? <Loader /> :
                    <div >
                         <div style={{ display: 'flex', alignItems: 'center',gap: 10, paddingBottom: 16,}}>
                            <IconButton onClick={() => { handleBack() }} title={'Back'} className={classes.backIconCls}>
                                < ArrowBackIcon style={{color: "#000"}}/>
                            </IconButton>
                           { selectedClause._id ? <h2 style={{fontWeight: 500}}>Edit {props.page.clauseTitle}</h2> : <h2 style={{fontWeight: 500}}>Add {props.page.clauseTitle}</h2>}
                        </div>
                        <div className={classes.newThemeForm}>
                            <div style={{ padding: 16, height: "calc(100vh - 230px)", overflow: "auto" }}>
                                <Grid container spacing={4}>
                                    {/* Left Column */}
                                    <Grid item xs={12} md={6}>
                                        <div className={classes.newThemeFieldGroup}>
                                            {subDataElements?.map((field) => {
                                                let de = allDataElementforClause[field.value]
                                                let type = de?.type
                                                
                                                if (field.value === 'description' || type === 'wysiwyg' || (type === 'number' && field.uiType === "range")) {
                                                    return null
                                                }
                                                
                                                return (
                                                    <div key={field.value} className={classes.newThemeField}>
                                                        <label className={classes.lables}>
                                                            {field.label}
                                                            {(field?.required || de?.required) && <span style={{ color: "#d32f2f" }}>*</span>}
                                                        </label>
                                                        {type === 'textarea' ? (
                                                            <div className={classes.newThemeTextAreaContainer}>
                                                                <TextField
                                                                    multiline
                                                                    minRows={3}
                                                                    variant="outlined"
                                                                    required={field.required}
                                                                    error={(isSubmitted && !selectedClause[field.value]) || countWords(selectedClause[field.value] || "") > 200 || (selectedClause[field.value] || "").length > 1500}
                                                                    className={classes.newThemeTextArea}
                                                                    value={selectedClause[field.value] || ""}
                                                                    onChange={(event) => handleTextareaChange(event, field, 200)}
                                                                    placeholder="Enter"
                                                                    helperText={
                                                                        countWords(selectedClause[field.value] || "") > 200 
                                                                            ? "Maximum 200 words allowed" 
                                                                            : (selectedClause[field.value] || "").length > 1500 
                                                                                ? "Maximum 1500 characters allowed" 
                                                                                : ""
                                                                    }
                                                                />
                                                                <div className={classes.newThemeWordCounter} style={{ color: (countWords(selectedClause[field.value] || "") > 200 || (selectedClause[field.value] || "").length > 1500) ? "#d32f2f" : "inherit" }}>
                                                                    {countWords(selectedClause[field.value] || "")}/200 Words
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <TextField
                                                                type={type === 'number' ? "number" : "text"}
                                                                variant="outlined"
                                                                error={isSubmitted && !selectedClause[field.value]}
                                                                className={classes.newThemeInput}
                                                                value={selectedClause[field.value] || ""}
                                                                onChange={(event) => handleInputChange(event, field)}
                                                                placeholder="Name"
                                                                helperText={isSubmitted && !selectedClause[field.value] ? "This field is required" : ""}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Grid>
                                    
                                    {/* Right Column */}
                                    <Grid item xs={12} md={6}>
                                        <div className={classes.newThemeFieldGroup}>
                                            {subDataElements?.map((field) => {
                                                let de = allDataElementforClause[field.value]
                                                let type = de?.type
                                                
                                                if (field.value !== 'description') {
                                                    return null
                                                }
                                                
                                                return (
                                                    <div key={field.value} className={classes.newThemeField}>
                                                        <label className={classes.lables}>
                                                            {field.label}
                                                            {(field?.required || de?.required) && <span style={{ color: "#d32f2f" }}>*</span>}
                                                        </label>
                                                        <TextField
                                                            type="text"
                                                            variant="outlined"
                                                            error={isSubmitted && !selectedClause[field.value]}
                                                            className={classes.newThemeInput}
                                                            value={selectedClause[field.value] || ""}
                                                            onChange={(event) => handleInputChange(event, field)}
                                                            placeholder="Enter"
                                                            helperText={isSubmitted && !selectedClause[field.value] ? "This field is required" : ""}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Grid>
                                    
                                    {subDataElements?.map((field) => {
                                        let de = allDataElementforClause[field.value]
                                        let type = de?.type
                                        
                                        if (type === 'wysiwyg' || (type === 'number' && field.uiType === "range")) {
                                            return (
                                                <Grid item xs={12} key={field.value}>
                                                    <div className={classes.newThemeField}>
                                                        <label className={classes.lables}>
                                                            {field.label}
                                                            {(field?.required || de?.required) && <span style={{ color: "#d32f2f" }}>*</span>}
                                                        </label>
                                                        {type === 'wysiwyg' ? (
                                                            <WysiwygEditor
                                                                value={selectedClause[field.value] || ""}
                                                                onChange={(val) => handleInputChange({ target: { value: val } }, field)}
                                                                error={isSubmitted && !selectedClause[field.value]}
                                                                required={field.required}
                                                                placeholder={'Enter ' + field.label}
                                                                isNewV1Theme = {isNewV1Theme}
                                                            />
                                                        ) : type === 'number' && field.uiType === "range" ? (
                                                            <div className={classes.newThemeSliderContainer}>
                                                                <div className={classes.newThemeSliderLabels}>
                                                                    <span className={classes.newThemeSliderLabel}>Min (0)</span>
                                                                    <span className={classes.newThemeSliderLabel}>Max (100)</span>
                                                                </div>
                                                                <Slider
                                                                    value={Number(selectedClause.threshold) || 0}
                                                                    onChange={handleThresholdChange}
                                                                    min={0}
                                                                    max={100}
                                                                    step={1}
                                                                    className={classes.newThemeSlider}
                                                                    valueLabelDisplay="on"
                                                                    error={isSubmitted && selectedClause.threshold === undefined}
                                                                />
                                                                {isSubmitted && selectedClause.threshold === undefined && (
                                                                    <FormHelperText error style={{ marginTop: 8 }}>This field is required</FormHelperText>
                                                                )}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </Grid>
                                            )
                                        }
                                        return null
                                    })}
                                </Grid>
                            </div>
                            <div className={classes.buttonContainer}>
                                    <Button variant="contained" className={classes.cancel}  onClick={handleBack}>Back</Button>
                                    <Button
                                        onClick={onSaveClick}
                                        variant="contained"
                                        className={classes.update}
                                        >
                                        {
                                            (Helpers.loading(props, '_save') || Helpers.loading(props, '_update')) ? <CircularProgress color='#fff' size={24} /> : (selectedClause._id ? "Update" : "Add")
                                        }
                                    </Button>
                            </div>
                        </div>
                    </div>
                }
            </>
        )}
        </div>
    )
}

const mapDispatchToProps = {
    getDataModelById,
    getContractDataById,
    clearReduxDataOfCurrentComponent,
    updateDataModelData,
    createDocument

}

const mapStateToProps = state => {
    return {
        formData: state.form,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClauseData))